module.exports={
  "Explore goal": "Udforsk mÃ¥let"
}
